import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import { motion } from 'framer-motion';
import './Philosophy.css';

// Import your images
import precisionImg from '../assets/1.jpg'; 
import luxuryImg from '../assets/2.jpg';
import securityImg from '../assets/3.jpg';
import healthcareImg from '../assets/4.jpg';

const Philosophy = () => {
  const philosophyItems = [
    {
      image: precisionImg,
      title: 'Precision Engineering',
      description: 'Every line of code is crafted with meticulous attention to detail, ensuring flawless performance in critical healthcare environments.',
      color: '#51A8B1'
    },
    {
      image: luxuryImg,
      title: 'Luxury Experience',
      description: 'We believe healthcare software should be a pleasure to use. Our interfaces combine elegance with intuitive design.',
      color: '#A8CF45'
    },
    {
      image: securityImg,
      title: 'Unmatched Security',
      description: 'Your data security is our fortress. We implement military-grade encryption and cutting-edge security protocols.',
      color: '#51A8B1'
    },
    {
      image: healthcareImg,
      title: 'Healthcare First',
      description: 'We understand the unique challenges of healthcare. Our solutions are designed by healthcare experts, for healthcare heroes.',
      color: '#A8CF45'
    }
  ];

  return (
    <Box className="philosophy-section" sx={{ py: 10, background: '#f8f9fa' }}>
      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <Typography
            variant="h3"
            align="center"
            sx={{
              fontFamily: 'Quicksand, sans-serif',
              fontWeight: 700,
              color: '#51A8B1',
              mb: 2,
            }}
          >
            Our Philosophy
          </Typography>
          <Typography
            variant="h5"
            align="center"
            sx={{
              fontFamily: 'Quicksand, sans-serif',
              color: '#666',
              mb: 6,
              maxWidth: '800px',
              margin: '0 auto 48px auto',
            }}
          >
            Quality is not an act, it's a habit. We're committed to transforming 
            healthcare through technology that respects both the practitioner and the patient.
          </Typography>
        </motion.div>

        <div className="philosophy-grid">
          {philosophyItems.map((item, index) => (
            <motion.div
              key={index}
              className="philosophy-card"
              whileHover={{ y: -10 }}
              style={{ borderTopColor: item.color }}
            >
              <div className="philosophy-icon">
                <img src={item.image} alt={item.title} className="philosophy-image" />
              </div>
              <h3 className="philosophy-title">{item.title}</h3>
              <p className="philosophy-description">{item.description}</p>
            </motion.div>
          ))}
        </div>
      </Container>
    </Box>
  );
};

export default Philosophy;